// This is model type enum to show which type of modal popup
// we want from within the component, this helps in comparison
// instead of using int or string values, and increase readability
// of the code
export enum InfoModalType {
    Email = 1,
    ContactNo,
    EmployeeLocation,
    Role
}